import { z } from "zod"

export const EmbeddedEventType = z.enum(["navigation", "layout", "notification", "keyPressed"])
export type EmbeddedEventType = z.infer<typeof EmbeddedEventType>

export const EmbeddedEventSchema = z.object({
  from: z.string(),
  type: EmbeddedEventType,
  data: z.any(),
})
export type EmbeddedEvent = z.infer<typeof EmbeddedEventSchema>

export const EmbeddedEventNavigationPayloadSchema = z.object({
  link: z.string(),
})
export type EmbeddedEventNavigationPayload = z.infer<typeof EmbeddedEventNavigationPayloadSchema>

export const EmbeddedWebphoneStatusSchema = z.enum(["expanded", "collapsed"])
export type EmbeddedWebphoneStatus = z.infer<typeof EmbeddedWebphoneStatusSchema>

export const EmbeddedSidePanelStateSchema = z.enum(["opened", "ready", "closed"])
export type EmbeddedSidePanelState = z.infer<typeof EmbeddedSidePanelStateSchema>

export const EmbeddedEventLayoutPayloadSchema = z
  .object({
    webPhoneStatus: EmbeddedWebphoneStatusSchema.optional(),
    sidePanelStateUpdated: EmbeddedSidePanelStateSchema.optional(),
  })
  .refine((value) => Boolean(value.webPhoneStatus || value.sidePanelStateUpdated), {
    message: "Layout payload must include webPhoneStatus or sidePanelStateUpdated",
  })
export type EmbeddedEventLayoutPayload = z.infer<typeof EmbeddedEventLayoutPayloadSchema>

export const EmbeddedEventNotificationPayloadSchema = z.object({
  title: z.string(),
  icon: z.string().optional(),
  body: z.string().optional(),
  badge: z.string().optional(),
  data: z.any().optional(),
  dir: z.enum(["auto", "ltr", "rtl"]).optional(),
  lang: z.string().optional(),
  requireInteraction: z.boolean().optional(),
  silent: z.boolean().nullish(),
  tag: z.string().optional(),
})
export type EmbeddedEventNotificationPayload = z.infer<typeof EmbeddedEventNotificationPayloadSchema>

export const ShortcutType = z.enum(["mod + K", "mod + P"])
export type ShortcutType = z.infer<typeof ShortcutType>

export const EmbeddedEventKeyPressedPayloadSchema = ShortcutType
export type EmbeddedEventKeyPressedPayload = z.infer<typeof EmbeddedEventKeyPressedPayloadSchema>

export function getEmbeddedSidePanelState(layoutData: unknown): EmbeddedSidePanelState | null {
  const result = EmbeddedEventLayoutPayloadSchema.safeParse(layoutData)
  if (!result.success) return null

  return result.data.sidePanelStateUpdated ?? null
}

export function getEmbeddedWebphoneStatus(layoutData: unknown): EmbeddedWebphoneStatus | null {
  const result = EmbeddedEventLayoutPayloadSchema.safeParse(layoutData)
  if (!result.success) return null

  return result.data.webPhoneStatus ?? null
}
